<template>
  <div class="navbar">
    <div class="logo">
      <img style="width: 220px;height: 61px;margin-top: -4px;" :src='navbarlogo'>
    </div>
    <div class="right-menu">
      <el-dropdown class="hover-effect" trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          {{realName}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-show="showChangePassword" @click.native='changePassword'>{{$t('self.menuClass.changePassword')}}</el-dropdown-item>
          <el-dropdown-item @click.native='logoutClick'>{{$t('self.loginClass.logout')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog :title="$t('self.changePasswordClass.changePassword')" center :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form" label-position="left" ref='form' :rules="rules">
        <el-form-item :label="$t('self.changePasswordClass.originalPassword')" :label-width="formLabelWidth" prop='repassword'>
          <el-input v-model="form.repassword" type="password" autocomplete="off" :placeholder="$t('self.changePasswordClass.inputOriginalPassword')" style="width: 260px;"></el-input>
        </el-form-item>
        <el-form-item :label="$t('self.changePasswordClass.newPassword')" :label-width="formLabelWidth" prop='newpassword'>
          <el-input v-model="form.newpassword" type="password" autocomplete="off" :placeholder="$t('self.changePasswordClass.inputNewPassword')" style="width: 260px;"></el-input>
        </el-form-item>
        <el-form-item :label="$t('self.changePasswordClass.sureNewPassword')" :label-width="formLabelWidth" prop='surepassword'>
          <el-input v-model="form.surepassword" type="password" autocomplete="off" :placeholder="$t('self.changePasswordClass.inputSureNewPassword')" style="width: 260px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureChangeClick('form')">{{$t('self.managementClass.sure')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
  data(){
    return{
      showText:'',
      realName:'',
      navbarlogo:'',
      showChangePassword:false,
      dialogFormVisible:false,
      form:{
        repassword:'',
        newpassword:'',
        surepassword:''
      },
      formLabelWidth:'200px',
      rules: {
        repassword: [
          { required: true, message: this.$t('self.changePasswordClass.inputOriginalPassword'), trigger: 'blur' },
          { min: 8, max: 16, message: this.$t('self.changePasswordClass.format'), trigger: 'blur' }
        ],
        newpassword: [
          { required: true, message: this.$t('self.changePasswordClass.inputNewPassword'), trigger: 'blur' },
          { min: 8, max: 16, message: this.$t('self.changePasswordClass.format'), trigger: 'blur' }
        ],
        surepassword: [
          { required: true, message: this.$t('self.changePasswordClass.inputSureNewPassword'), trigger: 'blur' },
          { min: 8, max: 16, message: this.$t('self.changePasswordClass.format'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    let locale = localStorage.getItem('locale')
    if(locale == 'zh'){
      this.navbarlogo = require('@/assets/images/chineselogo.png')
      this.showChangePassword = false
    }else if(locale == 'en'){
      this.navbarlogo = require('@/assets/images/englishlogo.png')
      this.showChangePassword = true
    }
  },
  mounted() {
    // 拉取用户信息
    this.userInfo()

    if(localStorage.getItem('locale') == 'zh'){
      this.showText ='English'
    }else if(localStorage.getItem('locale') == 'en'){
      this.showText ='简体中文'
    }
  },
  methods: {
    changePassword(){
      //每次打开前先清除遗留数据
      this.dialogFormVisible = true
      this.$refs.form.resetFields()
    },
    // 修改密码
    sureChangeClick(formName){
      this.$refs[formName].validate((valid) => {
        if(valid) {
          let repassword = this.form.repassword
          let newpassword = this.form.newpassword
          let surepassword = this.form.surepassword
          if(newpassword != surepassword){
            this.$message.error('The new password entered twice is inconsistent, please re-enter');
            return
          }
          //调用修改密码接口
          this.$axios.post('/user/modifyPassword',{
            oldPassword: repassword,
            newPassword: newpassword,
            reEnteyNewPassword:surepassword
          })
          .then(response => {
            console.log('平台端修改密码接口调用返回数据')
            console.log(response)
            let status = response.code
            let data = response.data
            let message = response.msg
            if (status == '0') {
              this.$message({
                message: 'Password changed successfully',
                type: 'success'
              });
            }else if(status == '-1'){
              this.$message.error(message);
            }
          })
          .catch(error => {
            console.log(error);
            this.abnormalSituation()
          });
          this.dialogFormVisible = false

        }else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    changeLanguage(){
      if(localStorage.getItem('locale') == 'zh'){
         localStorage.setItem('locale','en')
         this.showText ='English'
      }else{
        localStorage.setItem('locale','zh')
        this.showText ='简体中文'
      }
      location.reload();
    },
    logoutClick(){
      this.$confirm(this.$t('self.loginClass.logoutTips'), this.$t('self.loginClass.systemTips'), {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$t('self.accountClass.exit'),
          cancelButtonText:  this.$t('self.loginClass.cancel')
        })
          .then(() => {
            let _this = this
            this.$axios.get('/client/logout',{
              params: {

              }
            })
              .then(res => {
                if(res.code == 0){
                  localStorage.clear()
                  _this.$router.push({
                    path: '/'
                  })
                }
                if(res.code == -1){
                  _this.msg = res.msg
                }
              })
              .catch( error => {
                console.log(error);
                this.abnormalSituation()
              });
          })
          .catch(action => {

          });
    },

    // 拉取用户信息
    userInfo() {
      let _this = this
      this.$axios.get('/menu/userInfo',{
        params: {

        }
      })
        .then(res => {
          console.log("给手机发送验证码============",res);
          console.log('1111')
          console.log(res.data.id)
          if(res.data.id == 0 ||res.data.id.length == 0 ||res.data.id == null){
            this.$router.push({
              path: '/'
            })
            return
          }
          if(res.code == 0){
            _this.realName = res.data.realName
          }
          if(res.code==-1){
            _this.msg = res.data.msg
          }
        })
        .catch(error=> {
          console.log(error);
          this.abnormalSituation()
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar{
  height: 60px;
  overflow: hidden;
  position: relative;
  background: #e9d184;
  .logo{
    float: left;
    height: 100%;
    line-height: 60px;
    a{
      display: inline-block;
      height: 100%;
      img{
        height: 80%;
        vertical-align: middle;
        margin-right: 10px;
      }
      h1{
        margin: 0;
        line-height: 60px;
        display: inline-block;
        vertical-align: middle;
        color: #fff;
      }
    }
  }
  .right-menu{
    float: right;
    height: 100%;
    line-height: 60px;

    .hover-effect {
      cursor: pointer;
      padding: 0 10px;
      transition: background .5s;

      span{
        outline: none;
      }
      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }
  }
  .el-dropdown{
    color: #fff;
  }
  .el-icon--right{
    margin-left: 10px;
  }
}
</style>
